export class CreateRoomRequest
{    
    public name: string;
    public code: string;
    public subCode: string;
    public type: string;
    public nsf: number;
    public programId: string;
    public projectId: string;
    public companyId: string;
}